import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import type { CustomCardButtonFactory, IProps } from "./card-button.types";
import styles from "./card-button.module.scss";
import { polymorphicComponentWrapper } from "../../../../utilities";
import { Card } from "../../card-component";
import { Center } from "../../../center";
import { ActionIcon } from "../../../action-icon";
import { Group } from "../../../group";
import { Text } from "../../../text";
import { AutoMenu } from "../../../auto-menu";

/**
 * A card variant that displays a button with optional menu actions.
 * @param props.onClick Click handler for the button.
 * @param props.children Text or elements to display inside the button.
 * @param props.menu    Optional menu items for additional actions.
 * @returns            A styled card button with optional menu.
 */
const CardButton = polymorphicComponentWrapper<CustomCardButtonFactory, IProps>(
    "CardButton",
    ({ onClick, children, menu, ...props }, ref) => {
        return (
            <Card className={styles["root"]} ref={ref} color="gray" {...props}>
                <Center h="100%">
                    <Group gap="sm">
                        <AutoMenu keepMounted items={menu}>
                            <ActionIcon bdrs="xl" onClick={onClick} icon={faPlus} variant="default" color="gray" />
                        </AutoMenu>
                        <Text variant="medium" size="sm">
                            {children}
                        </Text>
                    </Group>
                </Center>
            </Card>
        );
    }
);

export { CardButton };
